import type { IconData } from '@stacksjs/iconify-core'

export const pin2Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M28.25 4.75c-8.284 0-15 6.716-15 15s6.716 15 15 15s15-6.716 15-15s-6.716-15-15-15m-19 15c0-10.493 8.506-19 19-19s19 8.507 19 19s-8.507 19-19 19a18.9 18.9 0 0 1-8.898-2.208c-4.014 2.855-8.009 5.682-11.199 7.705c-1.7 1.078-3.19 1.94-4.343 2.455c-.574.257-1.092.44-1.524.514c-.402.067-.895.068-1.232-.269s-.336-.83-.268-1.231c.073-.433.257-.95.513-1.524c.516-1.153 1.377-2.644 2.455-4.343c2.023-3.19 4.85-7.185 7.705-11.199a18.9 18.9 0 0 1-2.21-8.9m25.364-6.364a2 2 0 1 0 2.828-2.829c-5.077-5.077-13.308-5.077-18.385 0a2 2 0 0 0 2.829 2.829a9 9 0 0 1 12.728 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pin2Remix
